<template>
  <form :action="formAction" :method="effectiveMethod === 'get' ? 'get' : 'post'">
    <input v-if="csrfToken && effectiveMethod !== 'get'" type="hidden" name="authenticity_token" :value="csrfToken">
    <input v-if="effectiveMethod !== 'post' && effectiveMethod !== 'get'" type="hidden" name="_method" :value="effectiveMethod">

    <table class="hv-form-table">
      <tr>
        <th>IPv4 Global Address</th>
        <td><input v-model="ipv4" name="nat46mapping[ipv4]" type="text" size="20" class="form-control string required"></td>
      </tr>
    </table>

    <div class="vm-form-actions">
      <button type="submit" class="btn btn-primary">{{ submitLabel }}</button>
    </div>
  </form>
</template>

<script setup>
import { ref } from "vue"

const props = defineProps({
  formAction: {
    type: String,
    required: true
  },
  formMethod: {
    type: String,
    default: "post"
  },
  submitLabel: {
    type: String,
    default: "Save"
  },
  initialIpv4: {
    type: String,
    default: ""
  }
})

const csrfToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content") || ""
const effectiveMethod = props.formMethod.toLowerCase()
const ipv4 = ref(props.initialIpv4)
</script>
